export default {
  accepted_message: "ការភ្នាល់របស់អ្នកត្រូវបានទទួលយក។",
  waiting_message: "ការភ្នាល់របស់អ្នកកំពុងរងចាំ។",
  login: "សូមចូលគណនីដើម្បីបន្ត...",
  password_rule: "* ពាក្យសម្ងាត់ត្រូវបានខុសគ្នាតាមអក្សរធំតូច និងត្រូវមានពី 6 ដល់ 10 តួអក្សរ។",
  nickname_rule: "* អ្នកអាចកំណត់នាមហៅក្រៅសម្រាប់បង្ហាញ និងចូលគណនី (6 ដល់ 15 តួអក្សរឬលេខ)។ សូមចំណាំថា អ្នកអាចកំណត់បានតែម្តងប៉ុណ្ណោះ។ មិនអាចកែប្រែឬលុបចោលបានឡើយ។",
  change_password_succeed: "ប្តូរពាក្យសម្ងាត់ដោយជោគជ័យ។",
  add_secondary_succeed: "កំណត់នាមហៅក្រៅដោយជោគជ័យ។",
  succeed: "អ្នកបានបញ្ចប់សកម្មភាពដោយជោគជ័យ!",
  failed: "អ្នកបានបរាជ័យក្នុងការបញ្ចប់សកម្មភាព!",
  no_information_available: "គ្មានព័ត៌មាន។",
  select_display_language: "ជ្រើសរើសភាសាដែលអ្នកចង់ប្រើលំនាំដើម។",
  select_odds_type: "ជ្រើសរើសប្រភេទអូតដែលអ្នកចូលចិត្តបង្ហាញលំនាំដើម។",
  select_page_type: "ជ្រើសរើសប្រភេទទំព័រដែលអ្នកចូលចិត្តបង្ហាញលំនាំដើមសម្រាប់ទំព័រប្រកួតថ្ងៃនេះ និងទីផ្សារដើម។",
  select_show_score_map: "អនុញ្ញាតឱ្យប្រព័ន្ធបង្ហាញផែនទីពិន្ទុដោយស្វ័យប្រវត្តិពេលដាក់ភ្នាល់។",
  select_default_event_sorting: "ជ្រើសរើសលំដាប់ការរៀបចំព្រឹត្តិការណ៍លំនាំដើមដែលអ្នកចូលចិត្ត។",
  select_market_type: "ជ្រើសរើសទីផ្សារដែលអ្នកចូលចិត្ត។",
  select_page_size: "ជ្រើសរើសទំហំទំព័រដែលអ្នកចូលចិត្ត។",
  change_sports_menu_order: "សូមអូសកីឡាដើម្បីផ្លាស់ប្ដូរលំដាប់បង្ហាញនៅម៉ឺនុយ។",
  view_outstanding_bets_in_bet_list: "ការភ្នាល់មិនទាន់ដំណើរការអាចចំណាយពេល។ សូមចូលទៅបញ្ជីភ្នាល់ដើម្បីមើលស្ថានភាពថ្មីបំផុត។",
  time_display_in_gmt_plus_8: "ម៉ោងខាងលើបង្ហាញជាតម្លៃ GMT+8។",
  select_default_stake: "អនុញ្ញាតឱ្យប្រព័ន្ធបញ្ចូលចំនួនភ្នាល់ដែលបានកំណត់ និងចំនួនចុងក្រោយដោយស្វ័យប្រវត្តិ។",
  bet_empty: "សន្លឹកភ្នាល់របស់អ្នកគឺទទេ។ សូមចុចលើអូតក្នុងតារាងដើម្បីជ្រើសរើសការភ្នាល់។",
  no_event: "បច្ចុប្បន្នគ្មានការប្រកួតឬល្បែងណាមួយ។ សូមមើលកីឡាផ្សេងទៀតឬត្រលប់មកក្រោយ។",
  no_bets: "គ្មានការភ្នាល់កំពុងដំណើរការ",
  no_waiting: "គ្មានការភ្នាល់រងចាំ",
  no_void: "គ្មានការភ្នាល់ដែលបានលុប",
  odds_changed: "អូតបានផ្លាស់ប្តូរ,",
  confirmation: "តើអ្នកបញ្ជាក់ចង់ដាក់ភ្នាល់នេះមែនទេ?",
  olderversion: "រកឃើញកំណែចាស់, ចុច OK ដើម្បីធ្វើបច្ចុប្បន្នភាព ឬចុច Ctrl-F5។",
  gmt8: "ម៉ោងខាងលើបង្ហាញជាតម្លៃ GMT+8។",
  no_betting_market: "គ្មានទីផ្សារភ្នាល់",
  note_1: "ការភ្នាល់មិនទាន់ដំណើរការអាចចំណាយពេល។ សូមចូលទៅ ‘ភ្នាល់របស់ខ្ញុំ’ ដើម្បីមើលស្ថានភាពថ្មីបំផុត។",
  match_not_started: "ការប្រកួតមិនទាន់ចាប់ផ្ដើម",


  banner1a: "ជ្រើសរើសកីឡា",
  banner1b: "ចូលរួមក្នុងល្បែងភ្នាល់",
  banner1c: "ជាមួយនឹងជម្រើសកីឡាច្រើនជាង 90 ប្រភេទ និងការប្រកួតផ្ទាល់រាប់ពាន់ ដើម្បីអោយអ្នកភ្នាល់ អារម្មណ៍រំភើបមិនធ្លាប់ផុត។ កុំខកខានឱកាសឈ្នះរបស់អ្នក ជាមួយនឹងអូតល្អបំផុត និងជម្រើសកីឡាឆ្នើមៗ។",

  banner2a: "បង្វិលគ្រាប់បែបសាក់",
  banner2b: "បុករ៉ូឡេតឱ្យឈ្នះរង្វាន់ធំ",
  banner2c: "ទទួលបានប្រាក់រង្វាន់ ពីពេលដែលអ្នករីករាយជាមួយបទពិសោធន៍ល្បែងកាស៊ីណូដ៏ពេញលេញ នៅក្នុងបន្ទប់ប្រណិតរបស់យើង។ អង្គុយចូលលេងហ្គេមដែលអ្នកចូលចិត្ត និងទទួលបានបទពិសោធន៍ផ្ទាល់ជាមួយ Dealer ផ្ទាល់។",

  banner3a: "ការលេងហ្គេមដ៏ល្អបំផុត",
  banner3b: "បទពិសោធន៍បែបបំរើដ៏ប្រកបដោយការផ្លាស់ប្តូរ",
  banner3c: "ជម្រើសហ្គេមច្រើនដល់ថ្នាក់គ្មានទីបញ្ចប់។ សាកល្បងឥឡូវនេះ!",

  banner4a: "កីឡាអូឡាំពិក",
  banner4b: "តូក្យូ 2020",
  banner4c: "កីឡាអូឡាំពិករដូវក្តៅឆ្នាំ 2020 ដែលត្រូវធ្វើឡើងនៅទីក្រុងតូក្យូ ពីថ្ងៃទី 23 ខែកក្កដា ដល់ថ្ងៃទី 8 ខែសីហា ឆ្នាំ 2021 ជាកម្មវិធីកីឡាអន្តរជាតិនានាដែលមានមុខវិជ្ជាច្រើន។",
  banner4d: "យើងនាំយក EURO CUP 2020 មកវិញសម្រាប់អ្នក!",

  banner5a: "ការផ្សាយបន្តផ្ទាល់ និងវីដេអូសង្ខេប",
  banner5aa: "ចូលដល់សហគមន៍របស់អ្នកក្នុងពេលវេលាផ្ទាល់",
  banner5b: "មើលការផ្សាយបន្តផ្ទាល់ និងវីដេអូសង្ខេបល្អបំផុតតាមគេហទំព័រ និងទូរស័ព្ទ",
  banner5c: "ទទួលបានពិន្ទុកីឡាបច្ចុប្បន្នគ្រប់ទីកន្លែង និងគ្រប់ពេលវេលា",

  banner6a: "ការប្រយុទ្ធអេឡិចត្រូនិក",
  banner6b: "លេងហ្គេមប្រយុទ្ធល្អបំផុត",
  banner6c: "ប្រមូលតួអក្សរដែលអ្នកចូលចិត្ត បើកសង្គ្រាមភាគីប្រជែង ចូលដល់សង្វៀន និងអស់ស្នាដៃជាមួយសត្រូវ! លេងកាន់តែច្រើន ឈ្នះកាន់តែច្រើន!",

  banner7a: "ចំណុចប្រទាក់ថ្មីសម្រាប់ ESPORTS",
  banner7b: "បទពិសោធន៍ថ្មីទាំងស្រុង",
  banner7c: "ជម្រើសផ្សារច្រើនសម្រាប់ Esports បំព្រងដោយបទពិសោធន៍ភ្នាល់ដ៏ល្អបំផុត។",
  banner7d: "ហ្គេមម៉ាស៊ីវល្បីៗ អូតឈ្នះខ្ពស់ និងការដោះសោភ្នាល់រហ័ស!",

  banner8a: "ហ្គេម V",
  banner8b: "លេងហ្គេម និងទទួលបានជ័យជម្នះផ្លូវថ្មី",
  banner8c: "រីករាយជាមួយជ័យជម្នះលំដាប់ថ្មី!",
  banner8d: "ជ្រៀតចូលក្នុងប្រភេទហ្គេមផ្សេងៗ ចាប់ពីប្រកួតប្រជែងដល់ហ្គេមប្រយុទ្ធ និងសាកល្បងប្រភេទថ្មីៗដែលធ្វើអោយអ្នកគ្រប់គ្រាន់ជាច្រើនម៉ោង!",

  bannersb: "រីករាយជាមួយភាពរំភើបនិងសប្បាយរីករាយដែលមិនដាច់ចោល ជាមួយនឹងការប្រកួតកីឡាជាតិ និងអន្តរជាតិជាច្រើន។ ជាមួយពួកយើង អ្នកនឹងបានអូតល្អបំផុតជានិច្ច។",
  bannersl: "សម្រាកពីជីវិតប្រចាំថ្ងៃ ឈានចូលទៅក្នុងពិភពនិម្មិត ហើយសាកល្បងជីវិតថ្មីនៅក្នុងហ្គេមដែលមានពណ៌ស្រស់ស្អាតដល់ចិត្ត។ អ្នកនឹងចូលចិត្ត!",
  bannerlc: "ចូលទៅកាន់បន្ទប់កាស៊ីណូប្រណិតរបស់យើង សប្បាយជាមួយហ្គេមកាស៊ីណូជាច្រើន និងភ្ញាក់ផ្អើលជាមួយបទពិសោធន៍បែបផ្ទាល់ជាមួយ Dealer មានសម្រស់។",

  banner10a: "សូមជូនពរឲ្យអ្នកមានពេលវេលាសប្បាយ",
  banner10b: "ពេលដែលអ្នកជិះទូកតាមសំលេងសណ្ដេងគុន!",

  banner11a: "ពានរង្វាន់ពិភពលោក FIFA QATAR 2022 ការប្រកួតជាតិសំខាន់បំផុតក្នុងពិភពលោក",
  banner11b: "ពានរង្វាន់ 2022 នឹងធ្វើឡើងនៅប្រទេសកាតា ពីថ្ងៃទី 20 វិច្ឆិកា ដល់ 18 ធ្នូ ឆ្នាំ 2022",
  banner11c: "មានក្រុមចំនួនសរុប 32 (រួមទាំងក្រុមម្ចាស់ផ្ទះ កាតា) ដែលបានជាប់ឆ្នោតចូលរួមប្រកួត ដើម្បីដណ្តើមពានដ៏ធំបំផុតនៃកីឡាបាល់ទាត់នៅតំបន់មជ្ឍមណ្ឌល។",

  banner13a: "ក្រុមមួយ ក្តីស្រមៃមួយ ដើម្បីក្លាយជាជើងឯក",
  banner13b: "ត្រៀមខ្លួនសម្រាប់ការបង្ហាញសមត្ថភាព ការប្រកួតយុទ្ធសាស្ត្រ និងចិត្តខ្ពង់ខ្ពស់ ពេលដែលក្រុមនានា​ប្រកួតគ្នា​ក្នុងពានរង្វាន់ប្រចាំឆ្នាំ។ ព្រឹត្តិការណ៍នេះពោរពេញដោយការប្រកួតគូស្មើនិងវគ្គជម្រុះគួរអោយភ្ញាក់ផ្អើល។ មកចូលរួមជាមួយយើង ហើយរីករាយជាមួយកីឡាដ៏ស្រស់ស្អាត!",

  banner15a: "សូមជូនពរឲ្យអ្នកប្រកបដោយកិត្តិយស",
  banner15b: "សូមអបអរសាទរពិធីបុណ្យសង្រ្កាន្តឆ្នាំ 2023",
  banner15c: "មិនថាអ្នកឈ្នះឬចាញ់ក្នុងអតីតកាល មិនសំខាន់នោះទេ។ អ្វីដែលសំខាន់គឺការបន្តទៅមុខដោយមិនបោះបង់។ Wbet សូមជូនពរឱ្យអ្នកនិងគ្រួសាររីករាយក្នុងពិធីបុណ្យសង្រ្កាន្ត 2023។ សวัสดีปีใหม่!!!",

  banner16a: "សូមជូនពរអ្នកនិងគ្រួសារមានពិធីបុណ្យហារីរាយ៉៉ាបុសាដ៏ពោរពេញដោយពរ!",

  // banner16b: "Happy Songkran Festival 2023",

  join_us1: "ធ្វើឲ្យទីនេះក្លាយជាពិភពលោករបស់អ្នក",
  join_us2: "ជាមួយនឹងសកម្មភាព 24/7 និងផលិតផលភ្នាល់ដ៏អស្ចារ្យជាច្រើន យើងផ្ដល់សេវាសម្រាប់ចំណង់ចំណូលចិត្តគ្រប់ប្រភេទ។ បន្ថែមពីនេះ អ្នកក៏អាចទទួលបានបូណឺសគួរឱ្យចាប់អារម្មណ៍ ប្រូម៉ូសិនជាបន្តបន្ទាប់ និងការទូទាត់ប្រាក់យ៉ាងមានប្រសិទ្ធភាព ដើម្បីធានាបទពិសោធន៍ល្អបំផុតក្នុងការលេងហ្គេម។ ចាប់ផ្តើមជំហានដំបូង និងចុះឈ្មោះជាមួយយើងឥឡូវនេះ។ វារហ័ស ងាយស្រួល និងឥតគិតថ្លៃ។",
  join_us3: "ចូលរួមជាមួយយើងឥឡូវនេះ",

  icon1a: "បង្កើតឡើងសម្រាប់ទូរស័ព្ទដៃ",
  icon1b: "ហ្គេមរបស់យើងអាចចូលប្រើបានតាមឧបករណ៍ចល័តដ៏ពេញនិយម ដូច្នេះអ្នកអាចលេងបានគ្រប់ទីកន្លែងជាមួយឧបករណ៍ស្រឡាញ់របស់អ្នក",
  icon2a: "សុវត្ថិភាពនិងគាំទ្របច្ចេកទេសខ្ពស់",
  icon2b: "រីករាយនឹងហ្គេម និងធ្វើប្រតិបត្តិការជាមួយយើងដោយមានការផ្តល់សុវត្ថិភាពខ្ពស់ – គេហទំព័ររបស់យើងមានសុវត្ថិភាពបំពេញបញ្ចេញព័ត៌មានផ្ទាល់ខ្លួនរបស់អ្នក",
  icon3a: "បទពិសោធន៍លាយបញ្ចូលយ៉ាងសម្បើម",
  icon3b: "ទាក់ទាញ ងាយស្រួលប្រើ និងអន្តរកម្ម – យើងបានជ្រើសរើសផលិតផលពិសេសៗ ដើម្បីផ្ដល់បទពិសោធន៍រំភើបដល់អ្នក",
  icon4a: "សេវាអតិថិជន",
  icon4b: "ការពេញចិត្តរបស់អ្នកគឺជាលក្ខណៈឯកសិទ្ធិរបស់យើង។ យើងសូមស្វាគមន៍មតិយោបល់ ឬសំណួរណាដែលអាចជួយអោយយើងបម្រើអ្នកបានល្អប្រសើរជាងមុន",

  footer1a: "ការភ្នាល់ដោយមិនទាន់លើកលែង",
  footer1b: "ការភ្នាល់គឺខុសច្បាប់សម្រាប់កុមារដែលអាយុក្រោម 18 ឆ្នាំ។ រដ្ឋនីមួយៗហាមឃាត់កុមារផ្អែកលើអាយុចូលរួមភ្នាល់។ {fvalue} នឹងធ្វើការត្រួតពិនិត្យអាយុដោយចៃដន្យ ហើយប្រាក់ឈ្នះនឹងត្រូវបាត់បង់បើអ្នកភ្នាល់មានអាយុក្រោម 18 ឆ្នាំ។ © 2004–2019។ {fvalue} ជាផ្លាកសញ្ញាជាតិនានាជាសកល (Bookmaker កីឡាដែលមានអាជ្ញាប័ណ្ណ)។ រក្សាសិទ្ធិគ្រប់យ៉ាង។",

  contactus_title1: "ជំនាញសេវាអតិថិជនរបស់យើងមានស្រាប់ដើម្បីឆ្លើយសំណួររបស់អ្នក ទាំងអំពីការទូទាត់ ជាភាសាអង់គ្លេស និងភាសាចិន។",
  contactus_title2: "អាចមានការគិតថ្លៃការហៅទូរស័ព្ទអន្តរជាតិនៅចំពោះអ្នក។ ការហៅទូរស័ព្ទទៅកាន់យើងអាចត្រូវបានថតសំឡេងសម្រាប់ការការពារអតិថិជន ការផ្ទៀងផ្ទាត់ព័ត៌មាន ការធានាគុណភាព និងការអនុវត្តតាមច្បាប់។",


  days: "ថ្ងៃ",
  hours: "ម៉ោង",
  mins: "នាទី",
  secs: "វិនាទី",
  ldiff_changed: "ភាគរយបានផ្លាស់ប្តូរ",
  no_room: "គ្មានបន្ទប់ដែលអាចប្រើបាន។ សូមជ្រើសជម្រើសផ្សេងទៀត ហើយស្វែងរកម្ដងទៀត ឬត្រឡប់មកពេលក្រោយ។",
  people_in_this_room: "មនុស្សនៅក្នុងបន្ទប់នេះ",
  room_full: "បន្ទប់នេះពេញហើយ",
  room_joined: "អ្នកបានចូលរួមបន្ទប់នេះរួចហើយ",
  my_room: "បន្ទប់របស់ខ្ញុំ",
  pin_code: "ឧ. 123456",
  no_matches: "គ្មានការប្រកួតឬហ្គេមដែលអាចលេងបាននៅឡើយទេ។",
  are_you_sure: "តើអ្នកប្រាកដថាចង់បន្តសកម្មភាពនេះមែនទេ?",
  accept_terms: "ដោយចុចធីក អ្នកកំពុងបញ្ជាក់ថាអ្នកបានអាន យល់ និងយល់ព្រមនឹងលក្ខខណ្ឌខាងលើ។",
  accept_required: "សូមអាន យល់ និងយល់ព្រមនឹង<br />លក្ខខណ្ឌខាងលើ មុននឹងបន្ត។",
  must_accept_better_odds: "តាមលំនាំដើម ការភ្នាល់នឹងទទួលយកអត្រាដែលល្អជាងដោយស្វ័យប្រវត្តិ។ សូមយោងទៅកាន់លក្ខខណ្ឌសេវាសម្រាប់ព័ត៌មានបន្ថែម។",
  maintenance_notice: "បច្ចុប្បន្ននេះ យើងកំពុងធ្វើការថែទាំប្រព័ន្ធ។ សូមសាកល្បងម្ដងទៀតនៅពេលក្រោយ។",
  not_winning_prize_in_this_tournament: "មិនឈ្នះរង្វាន់នៅក្នុងការប្រកួតនេះទេ",
  you_did_not_join_this_room: "អ្នកមិនបានចូលរួមបន្ទប់នេះទេ",
  deduct_confirm: "នេះនឹងចាប់ផ្តើមហ្គេម ហើយគ្រាប់ឥណទានរបស់អ្នកនឹងត្រូវកាត់។<br />តើអ្នកប្រាកដថាចង់បន្តទេ?",
  over_max_match: "ការប្រកួតនៅក្នុងលីកនេះលើសចំនួនអតិបរមាដែលអាចជ្រើសបាន។<br />សូមពង្រីលីក ហើយជ្រើសការប្រកួតដែលអ្នកចង់បាន។",


  //tournament
  button_skip: "រំលងដំណើរណែនាំ",
  button_previous: "ថយក្រោយ",
  button_next: "បន្ទាប់",
  button_stop: "បញ្ចប់",
  button_continue: "បន្ត",
  tour_content_1: "<h6>សូមស្វាគមន៍មកកាន់ការប្រកួត WBET</h6><p>យើងមានមោទនភាពក្នុងការប្រកាសអំពីការប្រកួតថ្មីដ៏គួរឱ្យរំភើបសម្រាប់អ្នកគាំទ្ររបស់គេហទំព័ររបស់យើង។</p>",
  tour_content_2: "<h6>បន្ទប់សាធារណៈ</h6><p​សមាជិកប្រកួតប្រជែងគ្នាក្នុងហ្គេមដែលត្រូវបង់ថ្លៃចូលជាធម្មតា។</p>",
  tour_content_3: "<h6>បន្ទប់ឯកជន</h6><p>សមាជិកអាចបើកបន្ទប់ដើម្បីលេងជាមួយមិត្តភក្តិដោយប្រើលេខ PIN អញ្ជើញសម្រាប់ចូល។</p>",
  tour_content_4: "<h6>បន្ទប់សាធារណៈឥតគិតថ្លៃ</h6><p>រៀបចំដោយអង្គការផ្សេងៗនៅពេលមានព្រឹត្តិការណ៍ពិសេស សម្រាប់សមាជិកដោយឥតគិតថ្លៃ។</p>",
  tour_content_5: "<h6>ចំនួនអ្នកលេងអាចចូលបាន & ការគិតថ្លៃ</h6><p>អ្នកលេង៖ សមត្ថភាពនៃបន្ទប់។</p><p>ថ្លៃចូល៖ អាស្រ័យលើការផ្តល់ជូននៃបន្ទប់ (រូបិយប័ណ្ណរបស់ម្ចាស់គណនី)។</p>",
  tour_content_6: "<h6>ព័ត៌មានលម្អិតបន្ទប់</h6><p>ចុចទីនេះដើម្បីមើលស្ថិតិបន្ទប់ និងចូលរួមបន្ទប់។</p>",
  tour_content_7: "<h6>ព័ត៌មានលម្អិតអំពីរង្វាន់</h6><p>ប្រាក់រង្វាន់សរុបសម្រាប់អ្នកឈ្នះ & លេខសម្គាល់បន្ទប់ដើម្បីស្វែងរក។</p>",
  tour_content_8: "<h6>ព័ត៌មានចាប់ផ្តើមបន្ទប់</h6><p>ស្ថានភាពបន្ទប់ និងពេលវេលាចូលចុងក្រោយ។</p>",
  tour_content_9: "<h6>បង្កើតបន្ទប់ឯកជន</h6><p>បង្កើតបន្ទប់ឯកជនសម្រាប់លេង និងអញ្ជើញមិត្តភក្តិចូលរួមដោយ PIN ចូល។</p>",
  tour_content_10: "<h6ចំណាត់ថ្នាក់ពិន្ទុ</h6><p>លក្ខណៈពិសេសនេះបង្ហាញពិន្ទុសម្រាប់ការមើល និងតាមដានលទ្ធផលរបស់អ្នកលេង។</p>",
  
time_machine_information_HDP: "WBET Time Machine [HDP] គឺដើម្បីទស្សន៍ទាយថាក្រុមណានឹងរកគ្រាប់បាល់បានច្រើនជាងគេក្នុងអំឡុងពេលដែលបានជ្រើសរើស។",
time_machine_information_OU: "WBET Time Machine [OU] គឺដើម្បីទស្សន៍ទាយចំនួនគ្រាប់បាល់សរុបក្នុងអំឡុងពេលដែលបានជ្រើសរើស។"

};
